import { createFileRoute, notFound } from "@tanstack/react-router";
import AuthorProfile from "@/pages/AuthorProfile";
import NotFound from "@/pages/NotFound";
import { authorExists } from "@/lib/seo/exists.functions";

export const Route = createFileRoute("/_app/authors/$slug")({
  loader: async ({ params }) => {
    const exists = await authorExists({ data: params.slug });
    if (!exists) throw notFound();
    return null;
  },
  notFoundComponent: NotFound,
  component: () => <AuthorProfile />,
});
